<template>
  <main-page :user="user" color="green">
    <template v-slot:title> PROTOTYPE PROGRESS </template>

    <div class="container">
      <div v-if="!loading && (user.role != 'STUDENT' || team)" class="row content">
        <div class="col-4 zone-padding pt-4 text-left">
          <h1 class="mb-2 si-font si-text-orange">Team</h1>
          <config-select
            v-if="user.role != 'STUDENT'"
            class="vs-big mb-4"
            :options="teams"
            label="name"
            v-model="team"
          />
          <config-select
            v-if="user.role == 'STUDENT'"
            class="vs-big mb-4"
            :options="[team]"
            label="name"
            v-model="team"
            disabled
          />

          <h1 class="mt-4 mb-2 si-font si-text-yellow">Feedback Group</h1>
          <div
            class="mb-2"
            v-if="!context.is_contest || program.contest_config.peer_feedback"
          >
            <label class="md-check check-lg">
              <input type="checkbox" checked="checked" v-model="peer" />
              <i class="yellow"></i> Peer
            </label>
          </div>
          <div class="mb-2">
            <label class="md-check check-lg">
              <input type="checkbox" checked="checked" v-model="educator" />
              <i class="yellow"></i> Educator
            </label>
          </div>
          <div class="mb-2" v-if="!context.is_contest">
            <label class="md-check check-lg">
              <input type="checkbox" checked="checked" v-model="partner" />
              <i class="yellow"></i> Community Partner
            </label>
          </div>
          <div class="mb-2" v-if="context.is_contest">
            <label class="md-check check-lg">
              <input type="checkbox" checked="checked" v-model="judge" />
              <i class="yellow"></i> Judge
            </label>
          </div>
        </div>

        <div
          class="col-8 zone-padding text-left d-flex flex-column justify-content-center h-100"
        >
          <div class="text-left">
            <template v-if="Object.keys(explanations).length == 0">
              <div v-if="!chartData || chartData.length == 0" class="card p-5">
                <div class="text-center text-very-muted text-lg _800">No feedback</div>
              </div></template
            >
            <template v-for="block in explanations">
              <div :key="`header-${block.assignment_id}`" class="table-head border">
                <h2 class="my-0 si-font">{{ block.assignment_name }}</h2>
                <div
                  class="my-0 si-font text-lg text-muted"
                  style="line-height: 20px; padding-bottom: 4px"
                >
                  Feedback
                </div>
              </div>
              <table
                :key="`table-${block.assignment_id}`"
                class="table table-striped border text-md mb-1"
              >
                <thead>
                  <tr>
                    <th>Reviewer</th>
                    <th>Feedback</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in block.explanations" :key="i">
                    <td class="v-mid" style="min-width: 120px">
                      <div style="line-height: 1.2">
                        {{ getFeedbackName(row.user, i) }}
                      </div>
                      <div class="si-font text-muted" style="line-height: 1">
                        {{ row.user.role }}
                      </div>
                    </td>
                    <td class="v-mid">{{ row.text }}</td>
                  </tr>
                </tbody>
              </table>
              <div
                class="d-flex flex-column align-items-end mb-4"
                :key="`count-table-${block.assignment_id}`"
              >
                <div v-if="block.explanations">
                  Note: {{ block.explanations.length }} responses
                </div>
                <div>
                  {{ getExplanationCountDetails(block) }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div v-if="!loading && user.role == 'STUDENT' && !team">
        <h1 class="text-extra-muted mt-5" style="font-size: 64px">No Team</h1>
        <h3 class="text-extra-muted">
          You must be on a team in this class to view prototype results.<br />Please
          contact your teacher to put you on a team.
        </h3>
      </div>
    </div>

    <template v-slot:footer>
      <div class="col-6 row no-gutters text-right">
        <div class="dropdown dropdown-menu-right dropup" style="flex:1;">
          <button
            class="btn btn-si-secondary dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Export
          </button>
          <div class="dropdown-menu text-md" aria-labelledby="dropdownMenuButton">
            <button class="dropdown-item" @click="exportFeedback">All Feedback</button>
          </div>
        </div>
        <a class="btn btn-si-secondary ml-3" href="#/prototype_entry">Back</a>
      </div>
    </template>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import ConfigSelect from "@/components/ConfigSelect";

import PitchService from "@/services/PitchService";
import ProgramService from "@/services/ProgramService";
import SectionService from "@/services/SectionService";
import FileService from "@/services/FileService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import _ from "lodash";

export default {
  name: "PrototypeProgress",

  props: ["user"],

  components: { MainPage, ConfigSelect },

  data() {
    return {
      fs: fs,
      ld: _,
      loading: true,

      team: null,
      teamName: null,
      category: null,
      peer: false,
      educator: true,
      partner: false,
      judge: false,
      program: null,

      //Options
      context: null,
      teams: null,
      prototypeAssignments: null,
      prototypeOptions: [],
      categories: [],
      feedbacks: null,
      allFeedbacks: null,
      explanations: { students: [], teachers: [], partners: [], judges: [] },

      groups: [
        {
          label: "Peer",
          id: "STUDENT",
        },
        {
          label: "Educator",
          id: "TEACHER",
        },
        {
          label: "Community Partner",
          id: "PARTNER",
        },
        {
          label: "Judge",
          id: "JUDGE",
        },
      ],
    };
  },

  created() {
    this.loadData();
  },

  watch: {
    team() {
      if (this.team) {
        this.teamName = this.team.name;
      }
      this.loadFeedbacks(this.team).then(() => {
        this.processFeedbacks();
      });
    },
    peer() {
      this.processFeedbacks();
    },
    educator() {
      this.processFeedbacks();
    },
    partner() {
      this.processFeedbacks();
    },
    judge() {
      this.processFeedbacks();
    },
  },

  methods: {
    loadData() {
      BB.props({
        context: SectionService.getContextPrefilled(),
        program: ProgramService.getContextProgram(),
      })
        .then((r) => {
          this.loading = false;
          this.context = r.context.data;
          this.teams = this.context.teams;
          _.each(this.teams, (team) => {
            if (!team.name) {
              team.name = this.nameList(team.students);
              team.students = _.filter(team.students, (s) => {
                return this.context.student_ids.includes(s.id);
              });
            }
          });

          this.prototypeAssignments = this.context.prototypes;

          if (this.user.role == "STUDENT") {
            console.log("DO SELECT OWN ROLE");
            this.selectOwnTeam();

            //remove hidden feedback
            this.prototypeAssignments = _.filter(this.context.prototypes, {
              hide_feedback: false,
            });
          } else {
            this.prototypeAssignments = this.context.prototypes;
          }

          this.program = r.program.data;

          if (this.$refs.chart) {
            this.$refs.chart.updateOptions(this.chartOptions);
          }
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          Notie.error("Failed to load data");
        });
    },

    selectOwnTeam() {
      for (let team of this.teams) {
        console.log("team", team);
        for (let userID of team.user_ids) {
          console.log("userID", userID, this.user.id);
          if (userID == this.user.id) {
            console.log("SELECT TEAM", team.name);
            this.team = team;
            return;
          }
        }
      }
    },

    loadFeedbacks(team) {
      if (!team) return;

      return PitchService.getPitchFeedbacksPrefilled(team.id)
        .then((r) => {
          this.feedbacks = r.data;
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to load feedback data", e);
        });
    },

    getCollatedData(feedbacks) {
      let assignments = {};
      _.each(feedbacks, (f) => {
        if (!assignments[f.assignment_id]) {
          assignments[f.assignment_id] = {
            students: [],
            teachers: [],
            partners: [],
            judges: [],
          };
        }
        try {
          switch (f.user && f.user.role) {
            case "STUDENT":
              assignments[f.assignment_id].students.push(f);
              break;
            case "TEACHER":
              assignments[f.assignment_id].teachers.push(f);
              break;
            case "PARTNER":
              assignments[f.assignment_id].partners.push(f);
              break;
            case "JUDGE":
              assignments[f.assignment_id].judges.push(f);
              break;
          }
        } catch {
          console.log("ERROR LINE 338");
        }
      });

      return assignments;
    },

    processFeedbacks() {
      console.log("TEAM", this.team);

      let collatedFeedbacks = this.getCollatedData(this.feedbacks);

      this.explanations = {};

      _.each(this.prototypeAssignments, (assignment) => {
        let assignmentExplanations = [];
        let feedbacks = collatedFeedbacks[assignment.id];

        console.log("ASSIGNMENT", assignment, this.feedbacks);

        if (feedbacks) {
          console.log("FEEDBACKS", feedbacks);

          if (this.peer) {
            let expListings = this.getFeedbackSummary(feedbacks.students, assignment);
            assignmentExplanations = assignmentExplanations.concat(expListings);
          }

          if (this.educator) {
            let expListings = this.getFeedbackSummary(feedbacks.teachers, assignment);
            assignmentExplanations = assignmentExplanations.concat(expListings);
          }

          if (this.partner) {
            let expListings = this.getFeedbackSummary(feedbacks.partners, assignment);
            assignmentExplanations = assignmentExplanations.concat(expListings);
          }

          if (this.judge) {
            let expListings = this.getFeedbackSummary(feedbacks.judges, assignment);
            assignmentExplanations = assignmentExplanations.concat(expListings);
          }

          this.explanations[assignment.id] = {
            assignment_name: assignment.name,
            assignment_id: assignment.id,
            explanations: assignmentExplanations,
          };
        }
        console.log("EXPLANATIONS", this.explanations);
      });
    },

    getFeedbackSummary(feedbacks, assignment) {
      if (feedbacks.length == 0) {
        return [];
      }
      try {
        let explanations = [];
        _.each(feedbacks, (f) => {
          explanations.push({
            assignment_id: assignment.id,
            assignment_name: assignment.name,
            created_at: f.created_at,
            user: f.user,
            text: f.response.feedback,
          });
        });
        return explanations;
      } catch {
        console.log("ERROR LINE 412");
      }
    },

    getFeedbackRows(catID) {
      let set = this.feedbacks[catID];
      let feedbacks = [];
      _.each(set, (fb) => {
        if (
          (this.peer && fb.type == "STUDENT") ||
          (this.educator && fb.type == "TEACHER") ||
          (this.partner && fb.type == "PARTNER") ||
          (this.judge && fb.type == "JUDGE")
        ) {
          feedbacks.push(fb);
        }
      });
      return feedbacks;
    },

    getExplanationCountDetails(block) {
      console.log("BLOCK", block);
      let numStudents = 0;
      let numTeachers = 0;
      let numPartners = 0;
      let numJudges = 0;

      _.each(block.explanations, (e) => {
        console.log("EXPLANATION", e);
        if (!e.user) return;

        switch (e.user.role) {
          case "STUDENT":
            numStudents++;
            break;
          case "TEACHER":
            numTeachers++;
            break;
          case "PARTNER":
            numPartners++;
            break;
          case "JUDGE":
            numJudges++;
            break;
        }
      });

      let parts = [];

      if (this.peer) {
        parts.push(`${numStudents} peer`);
      }
      if (this.educator) {
        parts.push(`${numTeachers} educator`);
      }
      if (this.partner) {
        parts.push(`${numPartners} partner`);
      }
      if (this.judge) {
        parts.push(`${numJudges} judge`);
      }

      return parts.join(", ");
    },

    getFeedbackName(user, index) {
      if (this.user.role == "ADMIN" || this.user.role == "TEACHER") {
        return fs.displayName(user.name);
      } else {
        switch (user.role) {
          case "ADMIN":
            return `Educator ${index + 1}`;
          case "TEACHER":
            return `Educator ${index + 1}`;
          case "STUDENT":
            return `Student ${index + 1}`;
          case "PARTNER":
            return `Peer ${index + 1}`;
          case "JUDGE":
            return `Judge ${index + 1}`;
          default:
            return `User ${index + 1}`;
        }
      }
    },

    nameList(users) {
      var displayNames = [];
      for (var user of users) {
        displayNames.push(fs.displayName(user.name));
      }
      return displayNames.join(", ");
    },

    exportFeedback() {
      if (!this.allFeedbacks) {
        this.allFeedbacks = this.feedbacks;
      }

      _.each(this.allFeedbacks, (f) => {
        f.team = _.find(this.teams, {
          id: f.team_id,
        });
        f.assignment = _.find(this.prototypeAssignments, {
          id: f.assignment_id,
        });
        _.each(f.response.responses, (r) => {
          r.category = _.find(this.categories, {
            id: r.category_id,
          });
        });
      });

      FileService.exportPitchFeedback(
        this.allFeedbacks.filter((f) => f.assignment),
        this.context,
        this.categories,
        this.user.role == "TEACHER"
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  margin-top: 1rem;
}
.zone-padding {
  padding: 3rem;
}
.splash-button-link > img {
  transition: transform 0.15s ease-in-out;
}
.splash-button-link:hover > img {
  transform: scale(1.05);
}
.splash-button {
  width: 100%;
}
.table-head {
  background-color: #f0f0f0 !important;
  padding: 0.75rem;
  margin-bottom: 1rem;
}
.v-mid {
  vertical-align: middle;
}
.range-description {
  font-size: 0.8rem;
  text-align: center;
}
</style>
